import { addDays, isAfter } from 'date-fns';

export const ChatbotProductName = 'HUEチャットエージェント';
export const ChatbotIconPath = `${process.env.PUBLIC_URL}/images/logo/hue-nega.svg`;
export const ProjectBoardProductName = 'HUEプロジェクトボード';
export const ProjectBoardIconPath = `${process.env.PUBLIC_URL}/images/logo/hue-pb.svg`;
export const WorkflowProductName = 'HUEワークフロー';
export const WorkflowIconPath = `${process.env.PUBLIC_URL}/images/logo/hue-wf.svg`;
export const ProductIconFallbackPath = `${process.env.PUBLIC_URL}/images/logo/hue-nega.svg`;

export interface ServiceThemeColor {
  firstThemeColor: string;
  secondThemeColor: string;
}

export type ServiceType = 'pjb' | 'workflow' | 'chatbot';
export type ServiceInfo = {
  [key in ServiceType]: {
    name: string;
    nameJa: string;
    colors: ServiceThemeColor;
    icon: string;
  };
};

// nameJa will be deprecated
export const serviceInfo: ServiceInfo = {
  pjb: {
    name: ProjectBoardProductName,
    nameJa: ProjectBoardProductName,
    colors: {
      firstThemeColor: '#6A8AFF',
      secondThemeColor: '#6AA4FF',
    },
    icon: ProjectBoardIconPath,
  },
  workflow: {
    name: WorkflowProductName,
    nameJa: WorkflowProductName,
    colors: {
      firstThemeColor: '#0EC6BD',
      secondThemeColor: '#78D899',
    },
    icon: WorkflowIconPath,
  },
  chatbot: {
    name: ChatbotProductName,
    nameJa: ChatbotProductName,
    colors: {
      firstThemeColor: '#5E9BFF',
      secondThemeColor: '#78AEFF',
    },
    icon: ChatbotIconPath,
  },
};
export const serviceName = (serviceId: ServiceType): string => {
  return serviceInfo[serviceId]?.name ?? '不明なサービス';
};
export const serviceNameJa = (serviceId: ServiceType): string => {
  return serviceInfo[serviceId]?.nameJa ?? serviceName(serviceId);
};
export const serviceThemeColor = (
  serviceId: ServiceType,
): ServiceThemeColor => {
  return serviceInfo[serviceId].colors;
};
export const serviceIcon = (serviceId: ServiceType): string => {
  return serviceInfo[serviceId]?.icon || ProductIconFallbackPath;
};

const DAYS_UNTIL_TENANT_DELETION = 30;
export const isTenantDeleted = (expirationDateMs: number) => {
  const currentTime = new Date().getTime();
  const tenantDeletionTime = addDays(
    expirationDateMs,
    DAYS_UNTIL_TENANT_DELETION,
  );
  return isAfter(currentTime, tenantDeletionTime);
};
